"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_call(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "call-hi"), /*#__PURE__*/React.createElement("g", {
    id: "239a27c4-546b-426c-a3ad-871c17ff9c91",
    "data-name": "call-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cd3faa6d-cf82-4fef-9099-78392a34d0ed",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dfe84dd2-f6fd-4ba9-b050-0b2a15b5a1cd",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b9a734ab-6477-423c-a1f4-848b67b0bbdd",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3faf31ac-7d08-4a91-9dd7-017a35ec8530",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0e82c96c-9c60-4024-a7e5-8de99d98876a",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2aa0e7d8-54f4-4ac4-b8fb-b9b6f3b5eb1a",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b20b257b-16eb-41ad-8651-271af9a9809f",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "34be30a3-9b8d-4af3-9e63-a29072a517d7",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8dc0ebe9-7aa7-4f08-86b0-bee360172b5b",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3e75f673-9341-4e07-8252-a4e96d60a0e3",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "21f0a0e3-ab32-4d84-97b4-f36d24faffd0",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3585a3f8-ce6b-4ab1-ab28-e0de12e0b0cc",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9e55b9cd-0e9f-45b6-84f9-8fa2082a59df",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12df673e-7e99-4f55-bfa6-c0926fb6c5c6",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "02024926-bdba-4c86-a73c-84632f1ed2c2",
    "data-name": "<Pfad>",
    d: "M114.94,127.84l12.2-9.2c3.22-1.65,6.54-2.05,8.54-.82,3,1.86,28.44,18.87,30.59,20.38s3.13,5.78.12,9.94-16.79,20.58-22.55,20.37-29.79-.91-74.62-46S24.12,53.63,24,47.92,40.72,28.86,45,26s8.56-1.77,10,.3C56.71,28.62,73.27,54,75.09,56.86c1.24,2,.75,5.27-1,8.43s-8.86,15.23-8.86,15.23,4.86,8.37,21.41,25C94.53,113.61,114.94,127.84,114.94,127.84Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.39,146.13c-3,4.16-16.79,20.58-22.55,20.37s-29.79-.91-74.62-46C27.46,78.47,24.37,55,24,47.34a3.34,3.34,0,0,0,0,.58c.12,5.71.41,29.47,45.22,74.56s68.84,45.79,74.62,46,19.55-16.21,22.55-20.37a8.85,8.85,0,0,0,1.81-6.37A9.62,9.62,0,0,1,166.39,146.13Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.94,127.84h0l-.3-.19Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.55,76.62c-5.16-8-19.84-30.48-29.6-45.22-1,.83-2,1.71-3.06,2.63C45.52,50.1,61.79,75,65.27,80.48Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.66,127.65l-.15-.11h0Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.37,125.26,115,127.83c5.29,3.32,25.93,17.07,44,29.17.94-1,1.85-2,2.69-3C144.66,142.61,125.27,129.69,118.37,125.26Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.73,33.3l-.84.73C45.52,50.1,61.79,75,65.27,80.48l2.28-3.86-.62-1-1.66,2.82C61.88,73.15,46.35,49.38,35.73,33.3Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,155c-16.72-11.2-35.64-23.81-42.56-28.26L115,127.83c5.29,3.32,25.93,17.07,44,29.17.94-1,1.85-2,2.69-3l-1.11-.74C160,153.83,159.5,154.41,159,155Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5,76.71c2.25-3.82,5.52-9.41,6.61-11.42a11.21,11.21,0,0,0,1.6-6.64,13.41,13.41,0,0,1-1.6,4.64c-1.17,2.16-4.88,8.48-7.11,12.27",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })))))))))))))))));
}

var _default = ic_call;
exports.default = _default;